import adminRoutes from './cms'
import calculatorRoutes from './calculator'

export default [...adminRoutes, ...calculatorRoutes]
